export default "__VITE_ASSET__BP2a_KNa__"